import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import Layout from "./components/Layout";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import History from "./pages/History";
import Pricing from "./pages/Pricing";
import AITech from "./pages/AITech";
import Profile from "./pages/Profile";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import AdminHome from "./pages/admin/AdminHome";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminDocuments from "./pages/admin/AdminDocuments";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminSettings from "./pages/admin/AdminSettings";
import PaymentProcess from "./pages/PaymentProcess";
import PaymentLSSuccess from "./pages/PaymentLSSuccess";
import AuthCallback from "./pages/AuthCallback";
import DocumentDetail from "./pages/DocumentDetail";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

const Protected = ({ children, admin }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && !user.isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/payment/process/:pid" element={<Protected><PaymentProcess /></Protected>} />
            <Route path="/payment/success/:pid" element={<Protected><PaymentProcess successMode={true} /></Protected>} />
            <Route path="/payment/ls-success" element={<Protected><PaymentLSSuccess /></Protected>} />

            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
            <Route path="/ai" element={<Layout><AITech /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/faq" element={<Layout><FAQ /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
            <Route path="/terms" element={<Layout><Terms /></Layout>} />

            <Route path="/dashboard" element={<Protected><Layout><Dashboard /></Layout></Protected>} />
            <Route path="/history" element={<Protected><Layout><History /></Layout></Protected>} />
            <Route path="/document/:id" element={<Protected><Layout><DocumentDetail /></Layout></Protected>} />
            <Route path="/profile" element={<Protected><Layout><Profile /></Layout></Protected>} />

            <Route path="/admin" element={<Protected admin><Layout><AdminHome /></Layout></Protected>} />
            <Route path="/admin/users" element={<Protected admin><Layout><AdminUsers /></Layout></Protected>} />
            <Route path="/admin/documents" element={<Protected admin><Layout><AdminDocuments /></Layout></Protected>} />
            <Route path="/admin/payments" element={<Protected admin><Layout><AdminPayments /></Layout></Protected>} />
            <Route path="/admin/analytics" element={<Protected admin><Layout><AdminAnalytics /></Layout></Protected>} />
            <Route path="/admin/settings" element={<Protected admin><Layout><AdminSettings /></Layout></Protected>} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
